module.exports = __webpack_public_path__ + "static/img/COC2021-13.225d381.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-13.jpg
// module id = 8vyO
// module chunks = 0